module.exports = __webpack_public_path__ + "assets/img/mecha-ee29ce64.png";